
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Position, Scheme } from "@ronuse/norseu/core/variables";
import { Checkbox, Dropdown, InputText, PasswordInput } from "@ronuse/norseu/core/form";
import { Navbar } from "@ronuse/norseu/core/overlay";

export class NavbarPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    navbarControls(key) {
        return (
            <div style={{margin: "20px", display: "flex", flexDirection: "column"}}>
                <span style={{fontWeight: 600}}>Select your option</span>
                <div style={{marginTop: "10px", display: "flex", flexDirection: "column"}}>
                    <span>Email</span>
                    <InputText ref={this.emailRef} scheme={Scheme.PRIMARY} placeholder="Enter your email address"/>
                </div>
                <div style={{marginTop: "10px", display: "flex", flexDirection: "column"}}>
                    <span>Password</span>
                    <PasswordInput scheme={Scheme.PRIMARY} placeholder="Enter your email address"/>
                </div>
                <div style={{marginTop: "10px"}}>
                    <Checkbox scheme={Scheme.PRIMARY} label="Stay Signed in"/>
                </div>
                <div style={{marginTop: "15px"}}>
                    <Button text="Close" onClick={(e) => this.onHide(key)}/>
                    <Button scheme={Scheme.SUCCESS} text="Submit" onClick={(e) => this.onHide(key)}/>
                </div>
            </div>
        );
    }

    onHide(name) {
        this.setState({
            [`${name}`]: false
        });
    }

    buildDocumentation() {
        const navbarPositions = [
            { label: "Position.LEFT", value: Position.LEFT },
            { label: "Position.RIGHT", value: Position.RIGHT },
            { label: "Position.TOP", value: Position.TOP },
            { label: "Position.BOTTOM", value: Position.BOTTOM },
        ];

        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Button text="Show Basic" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showBasic: true})} />
                            <Navbar onOpenFocusRef={this.emailRef} isVisible={this.state.showBasic} onHide={(e) => this.setState({showBasic: false})}>
                                {this.navbarControls("showBasic")} 
                            </Navbar>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Props</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Button text="Fullscreen" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showFullScreen: true})} />
                            <Button text="Without Modal" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showWithoutModal: true})} />
                            <Button text="Toggle Responsive Navbar" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showCollapsibleModal: true})} />
                            
                            <Navbar fullScreen isVisible={this.state.showFullScreen} onHide={(e) => this.setState({showFullScreen: false})}>
                                {this.navbarControls("showFullScreen")} 
                            </Navbar>

                            <Navbar noOverlay isVisible={this.state.showWithoutModal} onHide={(e) => this.setState({showWithoutModal: false})}>
                                {this.navbarControls("showWithoutModal")} 
                            </Navbar>
                            
                            <Navbar isVisible={this.state.showCollapsibleModal} onHide={(e) => this.setState({showCollapsibleModal: false})} 
                                minDimension={{width: 500}}>
                                <div style={{margin: "20px"}}>
                                    This side bar will be hidden if schreen less than 500. Click the toggle button to make it visible<br/>
                                    Reduce the screen size to make the toggle button visible or click the button below<br/>
                                    <Button text="Close" onClick={(e) => this.onHide("showCollapsibleModal")}/>
                                </div>
                            </Navbar>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Position</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Dropdown options={navbarPositions} selectedOptionIndex={0} onSelectOption={(e) => this.setState({ navbarPosition: e.option.value } )}/>
                            <br/>
                            <Button text="Show" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showWithPosition: true})} />
                            <Navbar position={this.state.navbarPosition} isVisible={this.state.showWithPosition} onHide={(e) => this.setState({showWithPosition: false})}>
                                {this.navbarControls("showWithPosition")} 
                            </Navbar>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "Navbar",
            import_statement: "import { Navbar } from '@ronuse/norseu/core/overlay'",
            properties: this.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/overlay/NavbarPage.js"
        });
    }

    state = {
        pageSource: '',
        navbarPosition: Position.LEFT,
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "isVisible", type: "boolean", default: false, description: "If true the navbar and it modal will be rendered in DOM" },
        { name: "position", type: <a href='#/p/components/core/variables/position'>Position</a>, default: <a href='#/p/components/core/variables/position#center'>Position.CENTER</a>, description: "The position pop in the navbar from for transition animation" },
        { name: "dismissableModal", type: "boolean", default: true, description: "Remove/hide the navbar when the modal is clicked" },
        { name: "noOverlay", type: "boolean", default: false, description: "Prevent rendering the navbar modal" },
        { name: "className", type: "string", default: null, description: "CSS classes to apply to the navbar compound element" },
        { name: "style", type: "object", default: null, description: "CSS Style to apply to the navbar compound element" },
        { name: "modalClassName", type: "string", default: null, description: "CSS classes to apply to the navbar modal element" },
        { name: "modalStyle", type: "object", default: null, description: "CSS Style to apply to the navbar modal element" },
        { name: "fullScreen", type: "boolean", default: false, description: "Make the navbar full screen" },
        { name: "onOpenFocusRef", type: "React.Ref", default: null, description: "The component ref that receive focus once the dialog is visible in DOM" },
        { name: "onCloseFocusRef", type: "React.Ref", default: null, description: "The component ref that receive focus once the dialog is removed from DOM" },
        { name: "baseZIndex", type: "number", default: 1001, description: "The base z-index of the dialog" },
        { name: "transitionOptions", type: "object", default: "", description: "React transition group option for the dialog body" },
        { name: "allowScroll", type: "boolean", default: false, description: "If false the scroll bar of the main body will be hidden" },
        { name: "minDimension", type: "object", default: null, description: "If the screen is bigger than the set minDimension the navbar will be invisible e.g. minDimension={ width: 200, height: 600 }" },
        { name: "maxDimension", type: "object", default: null, description: "If the screen is bigger than the set maxDimension the navbar will be invisible e.g. maxDimension={ width: 500, height: 1000 }" },
        { name: "onShow", type: "function", default: "(event)", description: "The callback that is invoked when the dialog is visible in DOM" },
        { name: "onHide", type: "function", default: "(event)", description: "The callback that is invoked when the dialog is removed from the DOM" }
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
        { name: "setValue(value)", type: "function", description: "Set the value of the component internal HTML element" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}
